module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "nav-wrap"
  }, _vm._l((_vm.deptDataList), function(item) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.toUrl(item.WID)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../static/assets/icon.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.NAME))])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-col-center"
  }, [_c('div', {
    staticClass: "nav-title"
  }, [_vm._v("部门导航")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ab81a21!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 567
// module chunks = 0